import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
interface KpiCardProps {
  label: string;
  value: string | number;
  delta?: string;
  trend?: 'up' | 'down';
  color?: 'blue' | 'orange' | 'green' | 'neutral' | 'navy';
}
export function KpiCard({
  label,
  value,
  delta,
  trend,
  color = 'neutral'
}: KpiCardProps) {
  const colorClasses = {
    blue: 'border-l-blue-500',
    orange: 'border-l-brand-orange-500',
    green: 'border-l-green-600',
    neutral: 'border-l-slate-400',
    navy: 'border-l-brand-navy-900'
  };
  return <div className={`bg-white rounded-lg shadow-sm border-l-4 ${colorClasses[color]} p-4 min-w-[140px]`} data-id="element-121">
      <div className="text-xs font-medium text-slate-600 uppercase tracking-wide mb-1" data-id="element-122">
        {label}
      </div>
      <div className="text-2xl font-bold text-brand-navy-900 tabular-nums" data-id="element-123">
        {value}
      </div>
      {delta && <div className="flex items-center gap-1 mt-1" data-id="element-124">
          {trend === 'up' && <TrendingUp className="w-3 h-3 text-green-600" data-id="element-125" />}
          {trend === 'down' && <TrendingDown className="w-3 h-3 text-red-600" data-id="element-126" />}
          <span className={`text-xs font-medium ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`} data-id="element-127">
            {delta}
          </span>
        </div>}
    </div>;
}